import { ARH_VERSION_2_0_RELEASE_DATE, SCHEMA_VERSION } from "core/consts";
import type { RehabForms, SchemaVersion } from "core/types";

const SCHEMA_VERSIONS: SchemaVersion[] = Object.values(SCHEMA_VERSION);

function isSchemaVersion(value: unknown): value is SchemaVersion {
  return (
    typeof value === "string" &&
    SCHEMA_VERSIONS.includes(value as SchemaVersion)
  );
}

export function resolveArhVersion(
  forms?: RehabForms | null,
  referenceDate: Date = new Date(),
): SchemaVersion {
  const stored =
    forms?.general_form?.schema_version ?? forms?.medical_form?.schema_version;

  if (isSchemaVersion(stored)) {
    return stored;
  }

  // If either form already exists but neither carries a schema_version,
  // the data pre-dates the v2 introduction → treat as v1.
  if (forms?.general_form || forms?.medical_form) {
    return SCHEMA_VERSION.V1_1_0;
  }

  return referenceDate.getTime() >= ARH_VERSION_2_0_RELEASE_DATE.getTime()
    ? SCHEMA_VERSION.V2_0_0
    : SCHEMA_VERSION.V1_1_0;
}
